import { useEffect, useState} from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../apiEndpoints';

export const useGetOpportunityInfoGather = ({oppID, funnel}) => {
    const [oppDetails, setOppDetails] = useState(null);

    const fetchData = async () => {
        try {
            const queryParams = new URLSearchParams({
                sub_id: oppID
            })
            const response = await axios.get(
                `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_OPPORTUNITIES.INFO_GATHERING}/${funnel}?${queryParams.toString()}`
            );
            console.table("Response from opportunity info gather:", response.data);
            if (response.status === 200) {
                setOppDetails(response.data);
            }else{
                console.error("Failed to fetch opportunity info gather data:", response.data);
            }
        }catch (error) {
            console.error("Error fetching opportunity info gather data:", error);
        };
    };

    useEffect(() => {
        fetchData();
    }, [oppID, funnel]);

    return {oppDetails, refetch: fetchData};
}